// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PorticoPortalDataGroupModel {
    static getAttributeTypeMap() {
        return PorticoPortalDataGroupModel.attributeTypeMap;
    }
}
PorticoPortalDataGroupModel.discriminator = undefined;
PorticoPortalDataGroupModel.additionalProperties = false;
PorticoPortalDataGroupModel.attributeTypeMap = [
    {
        "name": "id",
        "baseName": "id",
        "type": "string"
    },
    {
        "name": "portalId",
        "baseName": "portalId",
        "type": "string"
    },
    {
        "name": "dataGroupId",
        "baseName": "dataGroupId",
        "type": "string"
    },
    {
        "name": "priority",
        "baseName": "priority",
        "type": "number"
    },
    {
        "name": "createdBy",
        "baseName": "createdBy",
        "type": "number"
    },
    {
        "name": "createdOn",
        "baseName": "createdOn",
        "type": "Date"
    },
    {
        "name": "dataGroup",
        "baseName": "dataGroup",
        "type": "PorticoDataGroupModel"
    },
];
//# sourceMappingURL=porticoPortalDataGroupModel.js.map